import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBedLinen = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 104,
	height: 80,
	viewBox: "0 0 104 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M91.779 18.323L92.057 32.147L89.029 30.358C86.268 28.727 86 28.104 86 23.31C86 18.4 85.785 17.936 82.75 16.315C80.199 14.953 77.135 14.596 68.5 14.655C62.45 14.697 54.125 14.731 50 14.731C45.875 14.731 37.55 14.697 31.5 14.655C22.865 14.596 19.801 14.953 17.25 16.315C14.215 17.936 14 18.4 14 23.31C14 28.093 13.728 28.729 11 30.341L8 32.113V18.723C8 11.359 8.30501 5.028 8.67801 4.656C9.05001 4.283 27.838 4.096 50.428 4.239L91.5 4.5L91.779 18.323ZM44.25 19.053C46.948 19.802 48 20.642 48 22.047C48 23.732 47.281 24.004 42.75 24.031C37.248 24.063 24.951 25.472 20.567 26.573C18.169 27.174 18 26.981 18 23.637C18 20.457 18.363 19.952 21.25 19.119C25.723 17.827 39.693 17.787 44.25 19.053ZM78.25 19.053C81.686 20.007 82 20.392 82 23.655C82 26.98 81.829 27.174 79.433 26.573C75.049 25.472 62.752 24.063 57.25 24.031C52.702 24.004 52 23.736 52 22.029C52 20.664 53 19.769 55.25 19.119C59.723 17.827 73.693 17.787 78.25 19.053ZM78.443 30.456C89.798 33.55 94.167 38.243 95.575 48.855L96.258 54H50H3.742L4.42499 48.855C6.08099 36.372 12.313 31.374 29.173 29.007C39.204 27.599 71.437 28.547 78.443 30.456ZM96 67V76H93C90.231 76 90 75.727 90 72.455C90 70.024 89.228 68.138 87.545 66.455L85.091 64H50H14.909L12.455 66.455C10.772 68.138 10 70.024 10 72.455C10 75.727 9.769 76 7 76H4V67V58H50H96V67Z",
		fill: "black"
	})]
});
const ForwardRef = forwardRef(SvgBedLinen);
export { ForwardRef as ReactComponent };
